/**
 * @generated SignedSource<<fc1a5a8d561a6be241b423735b22856a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "globalVariableId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "globalVariableId",
        "variableName": "globalVariableId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteGlobalVariable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteGlobalVariableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteGlobalVariableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40a07013c3843f4945c9fa725c990db9",
    "id": null,
    "metadata": {},
    "name": "DeleteGlobalVariableMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteGlobalVariableMutation(\n  $globalVariableId: ID!\n) {\n  deleteGlobalVariable(globalVariableId: $globalVariableId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "957a074dce753b0c169ed9726c58c911";

export default node;
